export interface Prompt {
  id: string;
  input: string;
}

const prompts: Prompt[] = [
  {
    id: 'weeklyFleetDistance',
    input: 'Qual a quilometragem percorrida semanalmente pela frota nos últimos 2 meses?',
  },
  {
    id: 'mostOffensiveIdleEngineGroups',
    input: 'Quais os grupos mais ofensores em motor ocioso na minha frota no último mês?',
  },
  {
    id: 'fleetRoadSpeedEvents',
    input: 'Quantos eventos de excesso de velocidade da via minha frota teve mensalmente, entre janeiro e julho de 2023?',
  },
  {
    id: 'insecureDistance',
    input: 'Qual é a tendência geral de eventos de distância insegura registrados na frota nos últimos três meses? Houve um aumento, diminuição ou permaneceu estável?',
  },
];

export default prompts;
